import { toMomentPortalTz, now as getSimpleDateNow, equals, fromMoment } from 'foundations-components/transitional/utils/SimpleDate';
import I18n from 'I18n';
export const FIVE_PM_IN_MINUTES = 17 * 60;
export const convertTimestampToSimpleDate = timestamp => {
  if (timestamp === null) {
    return undefined;
  }
  const moment = I18n.moment.portalTz(timestamp);
  return fromMoment(moment);
};
export const convertTimestampToMinutes = timestamp => {
  if (timestamp === null) {
    return undefined;
  }
  const moment = I18n.moment.portalTz(timestamp);
  return moment.hours() * 60 + moment.minutes();
};
export const convertToTimestamp = (date, timeInMinutes = 0) => {
  const dateMoment = toMomentPortalTz(date);
  const hours = Math.floor(timeInMinutes / 60);
  const minutes = timeInMinutes % 60;
  dateMoment.hours(hours).minutes(minutes).seconds(0).milliseconds(0);
  return dateMoment.valueOf();
};
export const isDueDateTimeValid = (selectedDate, selectedTimeInMinutes) => {
  if (!selectedDate && selectedTimeInMinutes === undefined) {
    return true;
  }
  // If one is set, then we need for the other to be set
  if (!selectedDate || selectedTimeInMinutes === undefined) {
    return false;
  }
  const currentTimestamp = Date.now();
  const selectedTimestamp = convertToTimestamp(selectedDate, selectedTimeInMinutes);
  return selectedTimestamp > currentTimestamp;
};
export const isToday = date => equals(date, getSimpleDateNow('portalTz'));
export const getCurrentMinutes = () => {
  const now = I18n.moment.portalTz();
  return now.hours() * 60 + now.minutes();
};
export const getMinTimeForToday = () => {
  const currentMinutes = getCurrentMinutes();
  return Math.ceil((currentMinutes + 1) / 30) * 30;
};
export const getDueDateDaysAway = dueDate => {
  const dueMoment = toMomentPortalTz(dueDate).startOf('day');
  const todayMoment = I18n.moment.portalTz().startOf('day');
  return dueMoment.diff(todayMoment, 'days');
};
export const getDefaultTimeForDate = date => {
  if (!date) {
    return undefined;
  }
  const currentMinutes = getCurrentMinutes();
  if (isToday(date) && currentMinutes > FIVE_PM_IN_MINUTES) {
    return getMinTimeForToday();
  }
  return FIVE_PM_IN_MINUTES;
};